import { createContext, useContext, useState } from 'react';

type Props = {
  children: React.ReactNode;
};

type TabValue = 'vin_info' | 'vehicle_info' | null;

const tabs: Array<{ value: TabValue; label: string }> = [
  { value: 'vin_info', label: 'VIN Info' },
  { value: 'vehicle_info', label: 'Vehicle Info' }
];

type VehicleUploadTabsContextBody = {
  selectedTab: TabValue;
  setSelectedTab: (tab: TabValue) => void;
  tabs: Array<{ value: TabValue; label: string }>;
};

const defaultValue: VehicleUploadTabsContextBody = {
  selectedTab: null,
  setSelectedTab: () => {},
  tabs
};

const VehicleUploadTabsContext = createContext(defaultValue);

export const VehicleUploadTabsContextProvider = ({ children }: Props) => {
  const [selectedTab, setSelectedTab] = useState<TabValue>(null);

  return (
    <VehicleUploadTabsContext.Provider
      value={{
        selectedTab,
        setSelectedTab,
        tabs
      }}
    >
      {children}
    </VehicleUploadTabsContext.Provider>
  );
};

export const useVehicleUploadTabsContext = () => {
  const context = useContext(VehicleUploadTabsContext);
  return context;
};
